module.exports = __webpack_public_path__ + "img/p49.d5927297.png";